"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[error.tsx]", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-3xl">⚠️</p>
      <h2 className="text-lg font-bold">Algo deu errado nesta página</h2>
      <p className="max-w-md text-sm opacity-70">
        {error.message || "Erro inesperado no client. Tente recarregar."}
      </p>
      {error.digest && (
        <p className="text-xs opacity-50 font-mono">ID: {error.digest}</p>
      )}
      <button
        onClick={() => reset()}
        className="mt-2 rounded-lg border px-4 py-2 text-sm font-semibold hover:bg-muted/30 transition-colors"
      >
        Tentar novamente
      </button>
    </div>
  );
}
